    // src/pages/client/ClientFolder.js
    import React, { useState } from 'react';
    import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
    import 'react-tabs/style/react-tabs.css';
    import Header from '../components/Header';
    import Footer from '../components/Footer';
    import ClientFolderTable from '../components/ClientFolderTable';
    import Sidebar from '../components/Sidebar';
    import './ClientFolder.css';

    const pillars = [
    { label: "Overall", collection: "lm_overall" },
    { label: "Nutrition", collection: "lm_nutrition" },
    { label: "Recipes", collection: "lm_recipes" },
    { label: "Exercise", collection: "lm_exercise" }
    ];

    export default function ClientFolder() {
    return (
        <>
        
        <div className="admin-layout">
            <Header />
            <div className="admin-body">
                <Sidebar />
            <div className="admin-content">
                <h2>Your LM Pillars</h2>
                <Tabs>
                <TabList>
                    {pillars.map(p => (
                    <Tab key={p.label}>{p.label}</Tab>
                    ))}
                </TabList>

                {pillars.map(p => (
                    <TabPanel key={p.collection}>
                    <ClientFolderTable collection={p.collection} />
                    </TabPanel>
                ))}
                </Tabs>
            </div>
            </div>
        </div>
        <Footer />
        </>
    );
    }
